/**
 * @desc 查询售后服务信息
 */

import { RequestConfig, request } from 'umi';

function req(useless?: any, config: Parameters<typeof request>[1] = {}) {
  return request<
    defs.store.WrapResponse<Array<defs.store.AfterSaleServiceInfoVO>>
  >(`/storeapi/after/sale/service/info`, {
    method: 'get',
    ...(config || {}),
  });
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.WrapResponse<
  Array<defs.store.AfterSaleServiceInfoVO>
>;
export default req;
